import axios from 'axios';
import { MaterialCategoryDTO } from '../dto/MaterialCategoryDTO';
import { routePrefix } from '../app/App';

export async function getMaterialCategories(query: string): Promise<MaterialCategoryDTO[]> {
  const url = `${routePrefix()}material-categories${query}`;
  const { data } = await axios.get<MaterialCategoryDTO[]>(url);
  return data;
}
